import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL;

export default function PendingApprovalsNotice({ userRole }) {
  const [result, setResult] = useState(null);
  const allowed = [1, 2].includes(userRole);

  useEffect(() => {
    if (!allowed) return;
    let active = true;
    let loading = false;
    async function refresh() {
      if (loading || document.visibilityState === 'hidden') return;
      loading = true;
      try {
        const { data } = await axios.get(`${API_URL}/users/approvals/count`, {
          headers: { token: localStorage.getItem('token') }
        });
        if (!Number.isInteger(data.total) || !Number.isInteger(data.verified)) throw new Error('Ogiltigt antal');
        if (active) setResult({ ...data, userRole });
      } catch {
        if (active) setResult({ error: true, userRole });
      } finally { loading = false; }
    }
    refresh();
    const interval = window.setInterval(refresh, 60000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [allowed, userRole]);

  if (!allowed || !result || result.userRole !== userRole || (!result.error && result.total === 0)) return null;
  return (
    <Link to="/account-approvals" className="theme-panel my-4 flex flex-wrap items-center justify-between gap-3 border-sky-400" aria-live="polite">
      {result.error ? <span className="text-sm text-slate-600">Antalet väntande kontogodkännanden kunde inte hämtas. Öppna kön.</span> : <>
        <span>
          <span className="block font-semibold text-slate-800">{result.total} {result.total === 1 ? 'konto väntar' : 'konton väntar'} på godkännande</span>
          <span className="mt-1 block text-sm text-slate-600">{result.verified} har verifierad e-post. Öppna kontogodkännande.</span>
        </span>
        <span aria-hidden="true" className="rounded-full bg-sky-700 px-3 py-1 text-sm font-bold text-white">{result.total}</span>
      </>}
    </Link>
  );
}
